import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  ShowProps,
  TextField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import { find } from "lodash";
import { changeRequestFormLogType } from "./conts";

const translateText = (text: string): string => {
  if (text) {
    const findText = find(changeRequestFormLogType, ["id", text]);

    return findText.name;
  }
};

const Logs = (_props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Logs</Typography>
        </Grid>
        <Grid item xs={6}>
          <ArrayField
            source="logs"
            fieldKey="id"
            sortBy="loggedAt"
            sortByOrder="DESC"
          >
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="id" />
              <FunctionField
                label="Description"
                render={(record: any) => {
                  if (record.status.toLowerCase() === "created") {
                    return (
                      <>
                        Created by{" "}
                        {!record.userId ? (
                          "System"
                        ) : (
                          <TextField
                            source="user.admin.fullName"
                            emptyText="-"
                          />
                        )}
                      </>
                    );
                  }

                  return (
                    <>
                      {translateText(record.type)} changed to {record.status} by{" "}
                      {!record.userId ? (
                        "System"
                      ) : (
                        <TextField source="user.admin.fullName" emptyText="-" />
                      )}
                    </>
                  );
                }}
              />
              <CustomDateField source="loggedAt" isDateTime />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Logs;
